import Vue from "vue";
import VueCarousel from 'vue-carousel';
import NavigationTicker from './components/NavigationTicker.vue';

Vue.use(VueCarousel);
Vue.component('navigation-ticker', NavigationTicker);

if(document.getElementById("ticker")) {
    new Vue({el: '#ticker'});
}

